import React from "react";
import { PAYMENT_INSTRUCTIONS } from "./InstructionData";
import { Accordion, AccordionItem } from "@nextui-org/react";

const PaymentInstructions = ({ bankName }) => {
  const Instruction =
    PAYMENT_INSTRUCTIONS[bankName] || PAYMENT_INSTRUCTIONS.MANDIRI;

  return (
    <Accordion variant="bordered">
      {Instruction.map((item, index) => (
        <AccordionItem
          key={index}
          aria-label={item.title}
          title={item.title}
          classNames={{
            trigger: "outline-none focus:outline-none",
            title: "font-semibold text-sm",
          }}
        >
          <ul className="list-disc pl-5 text-xs">
            {item.content.map((content, contentIndex) => (
              <li className="mb-2" key={contentIndex}>
                {content}
              </li>
            ))}
          </ul>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default PaymentInstructions;
